import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.GET_COUPON_RANKING:
            return { ...state, response: action.payload }
        case TYPE.UPDATE_COUPON_RANKING:
            return { ...state, response: action.payload }
            case TYPE.COUPON_SEARCH:
                return { ...state, response: action.payload }
        default:
            return state;
    }
}

